import type { Variants } from 'framer-motion';

// 全站统一 spring 缓动（Editorial Luxury 暖调）
export const EASE: [number, number, number, number] = [0.32, 0.72, 0, 1];

// 单元素入场：fade + 轻微上移 + 去模糊
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 28, filter: 'blur(6px)' },
  show: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { duration: 0.7, ease: EASE },
  },
};

// 容器：让子元素错落进入
export const staggerContainer: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1, delayChildren: 0.05 } },
};
